import React from "react";

export const More = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path d="M10.658 10.936c-.665 1.084-.998 1.627-1.423 1.816a1.5 1.5 0 01-1.22 0c-.425-.19-.758-.732-1.423-1.816l-1.26-2.054c-.72-1.174-1.08-1.761-1.044-2.245a1.5 1.5 0 01.618-1.103c.393-.284 1.082-.284 2.46-.284h2.519c1.377 0 2.066 0 2.46.284a1.5 1.5 0 01.617 1.103c.036.484-.324 1.07-1.044 2.245l-1.26 2.054z" />
    </svg>
  );
};
